import { IBaseAction } from '../../../../common/interfaces/IBaseAction'
export enum KeysPost {

    ADDPOST = 'react/common/posts/ADDPOST',
    ADDPOST_FULFILLED = 'react/common/posts/ADDPOST_FULFILLED',
    ADDPOST_REJECTED = 'react/common/posts/ADDPOST_REJECTED',

    LOADPOSTSUNDELIVERED = 'react/common/posts/LOADPOSTSUNDELIVERED',
    LOADPOSTSUNDELIVERED_PENDING = 'react/common/posts/LOADPOSTSUNDELIVERED_PENDING',
    LOADPOSTSUNDELIVERED_FULFILLED = 'react/common/posts/LOADPOSTSUNDELIVERED_FULFILLED',
    LOADPOSTSUNDELIVERED_REJECTED = 'react/common/posts/LOADPOSTSUNDELIVERED_REJECTED',

    LOADPOSTSDELIVERED = 'react/common/posts/LOADPOSTSDELIVERED',
    LOADPOSTSDELIVERED_PENDING = 'react/common/posts/LOADPOSTSDELIVERED_PENDING',
    LOADPOSTSDELIVERED_FULFILLED = 'react/common/posts/LOADPOSTSDELIVERED_FULFILLED',
    LOADPOSTSDELIVERED_REJECTED = 'react/common/posts/LOADPOSTSDELIVERED_REJECTED',

    DELIVERYPOST = 'react/common/posts/DELIVERYPOST',
    DELIVERYPOST_PENDING = 'react/common/posts/DELIVERYPOST_PENDING',
    DELIVERYPOST_FULFILLED = 'react/common/posts/DELIVERYPOST_FULFILLED',
    DELIVERYPOST_REJECTED = 'react/common/posts/DELIVERYPOST_REJECTED',

    CHANGE_DESCRIPTION = 'react/common/posts/CHANGE_DESCRIPTION',
    CHANGE_TITLE = 'react/common/posts/CHANGE_TITLE',
    CHANGE_RTE = 'react/common/posts/CHANGE_RTE',
    CHANGE_ASSOCIATEDTAG = 'react/common/posts/CHANGE_ASSOCIATEDTAG',
    CHANGE_YESNOQUESTION = 'react/common/posts/CHANGE_YESNOQUESTION',

    GETPOST = 'react/common/posts/GETPOST',
    GETPOST_FULFILLED = 'react/common/posts/GETPOST_FULFILLED',
    GETPOST_REJECTED = 'react/common/posts/GETPOST_REJECTED',

    DELETEPOST = 'react/common/posts/DELETEPOST',
    DELETEPOST_FULFILLED = 'react/common/posts/DELETEPOST_FULFILLED',
    DELETEPOST_REJECTED = 'react/common/posts/DELETEPOST_REJECTED',

    GETCONTENT = "react/common/posts/GETCONTENT",
    GETCONTENT_FULFILLED = "react/common/posts/GETCONTENT_FULFILLED",
    GETCONTENT_REJECTED = "react/common/posts/GETCONTENT_REJECTED",
    
    LOADVOTES = 'react/common/posts/LOADVOTES',
    LOADVOTES_FULFILLED = 'react/common/posts/LOADVOTES_FULFILLED',
    LOADVOTES_REJECTED = 'react/common/posts/LOADVOTES_REJECTED',
    
    LOADVOTESTATS = 'react/common/posts/LOADVOTESTATS',
    LOADVOTESTATS_FULFILLED = 'react/common/posts/LOADVOTESTATS_FULFILLED',
    LOADVOTESTATS_REJECTED = 'react/common/posts/LOADVOTESTATS_REJECTED',
    
    CLEAR_FIELDS = 'react/common/posts/CLEAR_FIELDS',
    CHANGE_IMAGEBASE64 = 'react/common/posts/CHANGE_IMAGEBASE64',
    NEWPOST = 'react/common/posts/NEWPOST',


    DOWNLOAD = "react/common/posts/DOWNLOAD",
    PRINT = "react/common/posts/PRINT",
    CHANGE_SURVEYTEXT = "react/common/posts/CHANGE_SURVEYTEXT",
    
    OTHER_ACTION = 'react/common/posts/__any_other_action__',
}

export type TypesPost = IBaseAction<KeysPost>;